import { EMPTY_LIST } from '../../../../constants/common'
import { DATE_FULL_FORMAT } from '../../../../constants/date'
import { MENU_RENTAL_PORTAL_ITEM } from '../../../../constants/menu'
import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../../constants/route'
import { formatDate } from '../../../Table'
import { getRentalPortalSubsectionLink } from '../../RentalPortal.utils'

import {
  IMPORT_LOG_FILTER_ALL,
  IMPORT_LOG_READ_KEY_SEPARATOR,
  IMPORT_RUN_ACTION,
  IMPORT_RUN_STATUS,
  IMPORT_RUN_STATUSES,
} from './IntegrationsImportLog.constants'
import { getMockImportRunSources } from './IntegrationsImportLog.mocks'

function getImportLogParentBreadcrumbs(t) {
  return [
    {
      id: MENU_RENTAL_PORTAL_ITEM.title,
      title: t(MENU_RENTAL_PORTAL_ITEM.title),
      to: `/${ROUTE_PATH_LIST_RENTAL_PORTAL.root}`,
    },
    {
      id: 'RentalPortal.SettingsTitleKey',
      title: t('RentalPortal.SettingsTitleKey'),
      to: getRentalPortalSubsectionLink(ROUTE_PATH_LIST_RENTAL_PORTAL.settings),
    },
  ]
}

export function getImportLogLink() {
  return getRentalPortalSubsectionLink(
    ROUTE_PATH_LIST_RENTAL_PORTAL.settingsImportLog
  )
}

export function getImportRunLink(runId) {
  return `${getImportLogLink()}/${runId}`
}

export function getImportRunStatusOptions(t) {
  return [
    {
      label: t('RentalPortal.IntegrationsRunStatusAllKey'),
      value: IMPORT_LOG_FILTER_ALL,
    },
    ...Object.values(IMPORT_RUN_STATUS).map(status => ({
      label: t(IMPORT_RUN_STATUSES[status].text),
      value: status,
    })),
  ]
}

export function getImportRunSourceOptions(t) {
  return [
    {
      label: t('RentalPortal.IntegrationsRunSourceAllKey'),
      value: IMPORT_LOG_FILTER_ALL,
    },
    ...getMockImportRunSources().map(source => ({
      label: source,
      value: source,
    })),
  ]
}

export function getIsImportRunCountAlarming(count) {
  return count > 0
}

export function getIsImportRunRunning(run) {
  return run.status === IMPORT_RUN_STATUS.running
}

export function getIsImportRunSuccess(run) {
  return run.status === IMPORT_RUN_STATUS.success
}

export function getIsImportRunReprocessable(run) {
  return !getIsImportRunRunning(run) && !getIsImportRunSuccess(run)
}

export function getCanImportRunReprocess(run) {
  return Boolean(run.permissions?.can_reprocess)
}

export function getImportRunActions(item) {
  return getIsImportRunReprocessable(item)
    ? [
        {
          danger: true,
          disabled: !getCanImportRunReprocess(item),
          label: 'RentalPortal.IntegrationsRunReprocessKey',
          tooltipContent: getCanImportRunReprocess(item)
            ? null
            : 'RentalPortal.IntegrationsRunReprocessDeniedKey',
          value: IMPORT_RUN_ACTION.reprocess,
        },
      ]
    : EMPTY_LIST
}

export function formatImportRunDate({ date, locale, timezone }) {
  return formatDate({
    date,
    dateFormat: DATE_FULL_FORMAT,
    locale,
    timezone,
    useTodayFormat: false,
  })
}

export function getIsImportRunActionReprocess(action) {
  return action === IMPORT_RUN_ACTION.reprocess
}

export function getIsImportRunsEmpty({
  hasError,
  isInitiated,
  isLoading,
  items,
}) {
  return isInitiated && !isLoading && !hasError && items.length === 0
}

export function getImportLogBreadcrumbs({ t, title }) {
  return [
    ...getImportLogParentBreadcrumbs(t),
    {
      id: 'RentalPortal.IntegrationsTitleKey',
      title: t('RentalPortal.IntegrationsTitleKey'),
      to: getRentalPortalSubsectionLink(
        ROUTE_PATH_LIST_RENTAL_PORTAL.settingsIntegrations
      ),
    },
    { id: title, title },
  ]
}

export function getImportRunBreadcrumbs({ t, title }) {
  return [
    ...getImportLogParentBreadcrumbs(t),
    {
      id: 'RentalPortal.IntegrationsImportLogTitleKey',
      title: t('RentalPortal.IntegrationsImportLogTitleKey'),
      to: getImportLogLink(),
    },
    { id: title, title },
  ]
}

export function getImportLogReadKey(params) {
  return params.join(IMPORT_LOG_READ_KEY_SEPARATOR)
}

export function getIsImportLogReadCurrent({ readId, readIdRef }) {
  return readIdRef.current === readId
}
